import { Event, useStore } from '@mirai/data-sources';
import { DEFAULT_DATE_FORMAT, parseDate, useLocale } from '@mirai/locale';
import { ServiceBooking } from '@mirai/services';
import { Button, Calendar, Modal, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { ERROR } from '../../../Core.constants';
import { BookingDates } from '../../__shared__';
import { EVENT, valueFormat } from '../../helpers';
import { FORMAT_DATE } from '../Booking.constants';
import { L10N } from '../Booking.l10n';
import * as style from '../Booking.module.css';

const ModalCalendar = ({ dataSource: { id } = {}, onClose, onConfirm = () => {}, token, ...others }) => {
  const { dateFormat, locale, translate } = useLocale();
  const {
    value: { calendar: { rangeMaxDays, to } = {} },
  } = useStore();

  const [busy, setBusy] = useState();
  const [value, setValue] = useState([]);

  const handleChange = (next = []) => {
    setValue(valueFormat(next));
  };

  const handleCheckAvailability = async () => {
    setBusy(true);
    const response = await ServiceBooking.modification.date.quote({ id, checkIn, checkOut, token }).catch((error) => {
      const isWarning = error?.code === 404;

      Event.publish(EVENT.NOTIFICATION, {
        error: !isWarning,
        warning: isWarning,
        defaultMessage: translate(
          isWarning ? L10N.NOTIFICATION_WARNING_NO_AVAILABILITY : L10N.NOTIFICATION_ERROR[ERROR.UNKNOWN],
          {
            checkIn: dateFormat(parseDate(checkIn), FORMAT_DATE),
            checkOut: dateFormat(parseDate(checkOut), FORMAT_DATE),
          },
        ),
      });
    });
    setBusy(false);
    setValue([]);

    if (response) {
      onClose();
      onConfirm(response);
    }
  };

  const [checkIn, checkOut] = value || [];

  return (
    <Modal {...others} fit title={translate(L10N.LABEL_WHEN)} onClose={onClose}>
      <View className={style.modalCalendar}>
        <Calendar
          {...{ locale, rangeMaxDays, to, value }}
          format={DEFAULT_DATE_FORMAT}
          range
          onChange={handleChange}
          className={style.calendar}
          testId="booking-edit-calendar"
        />
        <View row className={style.footer}>
          <BookingDates
            {...{ from: checkIn ? parseDate(checkIn) : undefined, to: checkOut ? parseDate(checkOut) : undefined }}
          />
          <Button
            busy={busy}
            disabled={value.length !== 2 || !checkIn || !checkOut}
            wide
            onPress={handleCheckAvailability}
            testId="booking-check-button"
          >
            {translate(L10N.ACTION_CHECK_AVAILABILITY)}
          </Button>
        </View>
      </View>
    </Modal>
  );
};

ModalCalendar.displayName = 'Mirai:Core:Booking:ModalCalendar';

ModalCalendar.propTypes = {
  dataSource: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  token: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export { ModalCalendar };
